export const AUTOMATIC_OVERDUE_FOLLOW_UPS_SECTION_ID = 'automatic-overdue-follow-ups'
